export default {
  navigationBarTitleText: '验收未通过'// 未通过原因
};
